import * as Route from "./route";
import * as Page from "./page";
import * as Domain from "./domain";
import * as Shows from "./shows";
import * as UI from "./ui";
import * as Tixly from "./tixly";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { connectRouter, routerMiddleware } from "connected-react-router";
import { History, createMemoryHistory } from "history";
import { AppState } from ".";
import { isBrowserContext, isDevelopment } from "../util/ContextHelper";

export default function configureStore(initialState?: AppState, history?: History) {
    if (!history) {
        history = createMemoryHistory();
    }

    const middleware = [thunk, routerMiddleware(history)];

    const rootReducer = combineReducers({
        route: Route.reducer,
        page: Page.reducer,
        domain: Domain.reducer,
        // basm: Basm.reducer,
        tixly: Tixly.reducer,
        shows: Shows.reducer,
        ui: UI.reducer,
        router: connectRouter(history),
    });

    const composeEnhancers = isBrowserContext() && isDevelopment() && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

    const enhancer = composeEnhancers(applyMiddleware(...middleware));

    const store = createStore(rootReducer, initialState, enhancer);

    return store;
}
